'use strict';
// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('RelatorioFechamentoCtrl', function($scope,
  AtividadesService, GlebasService, LoadingService, MessagesService,
  RelatorioFechamentoService, $rootScope, $q) {
  // eslint-disable-next-line
  const error = function(error) {
    if (error) {
      console.error(error);
    }
    MessagesService.alert('Ocorreu um erro, tente novamente mais tarde.');
  };

  $scope.loadingRelatorio = false;

  const verifyJobProgress = (param) => {
    $scope.loadingRelatorio = true;
    const clear = (intervalo) => {
      $scope.loadingRelatorio = false;
      $rootScope.relatorioFechamento = null;
      clearInterval(intervalo);
    };

    const intervalo = setInterval(() => {
      RelatorioFechamentoService.download(param).then((response) => {
        const { data } = response;
        if (data.status === 'complete') {
          $rootScope.$broadcast('terminou_fechamento', {
            url: data.pdf_url,
            name: 'Relatório de Fechamento'
          });
          clear(intervalo);
        }
        if (data.status === 'failed' || data.status === 'interrupted') {
          $rootScope.$broadcast('falhou_fechamento', {
            url: 'Não foi possível gerar o arquivo.',
            name: 'Relatório de Fechamento'
          });
          clear(intervalo);
        }
      });
    }, 15000);
  };

  $scope.gerar = async function() {
    LoadingService.showLoading();
    RelatorioFechamentoService.gerar($scope.filters)
      .then(async(response) => {
        $rootScope.relatorioFechamento = true;
        verifyJobProgress(response.data);
      })
      .catch(function(exception) {
        error(`Falha ao gerar o relatório de fechamento - ${exception}`);
        // eslint-disable-next-line
      }).finally(LoadingService.hideLoading);
  };

  $scope.clearGlebas = function() {
    $scope.filters.glebas = [];
  };

  $scope.glebasPropriedade = [];

  $scope.allGlebas = function() {
    $scope.filters.glebas = $scope.glebasPropriedade;
  };

  function init() {
    LoadingService.showLoading();

    return $rootScope.initialize.then(function() {
      const promises = [
        AtividadesService.listComEmpreendimento(),
        GlebasService.list({ propriedade: $rootScope.currentPropriedade.id })
      ];

      $q.all(promises).then(function(result) {
        $scope.atividades = result[0].data;
        $scope.glebasPropriedade = result[1].data;
        $scope.filters = {
          propriedade: $rootScope.currentPropriedade,
          glebas: $scope.glebasPropriedade,
          timeline: true,
          exibir_fotos: false,
          exibir_anotacoes: false
        };
      });
      if ($rootScope.relatorioFechamento) {
        $scope.loadingRelatorio = true;
      }
    }).catch(function(exception) {
      console.error('Falha ao inicializar controller do relatório de fechamento', exception);
      error();
    // eslint-disable-next-line
    }).finally(LoadingService.hideLoading);
  }
  init();

  $scope.$on('terminou_fechamento', () => {
    $scope.loadingRelatorio = false;
  });

  $scope.$on('falhou_fechamento', () => {
    $scope.loadingRelatorio = false;
  });
});
